import { client } from "../client";

export const fetchTokenState = async (token: string) => {
	const response = await client.post<object>(`tokens/state/`, {
		token: token,
	});
	return response.data;
};
